import * as React from "react";
import { Button as GrommetButton, ButtonType } from "grommet";

import styled, { css } from "styled-components";
import { DefaultTheme } from "styled-components";

export interface ButtonProps extends ButtonType {
  className?: string;
  label: string;
  iconDirection?: "left" | "right";
  display?: "inline" | "flex";
  backgroundColor?: keyof DefaultTheme["colors"];
  textColor?: keyof DefaultTheme["colors"];
  loading?: boolean;
  form?: string;
  small?: boolean;
}

const Wrapper = styled.div<{display?: "inline" | "flex"}>`
  z-index: 1;
  display: ${props => props.display || "inline"};
  position: relative;
`;

const StyledButton = styled(GrommetButton)<ButtonProps>`
  flex-direction: ${props => props.reverse ? "row" : "row-reverse"};

  ${props =>
    !props.plain &&
    !props.disabled &&
    css`
      font-family: ${props.theme.font.family.primary};
      font-weight: ${props.theme.font.weights.medium};
      position: relative;
      border-radius: ${props.theme.borderRadius.medium};
      height: 4rem;
      background: ${props.backgroundColor ? props.theme.colors[props.backgroundColor] : props.theme.colors.Primary500};
      border-color: ${props.backgroundColor ? props.theme.colors[props.backgroundColor] : props.theme.colors.Primary500};
      color: ${props.textColor ? props.theme.colors[props.textColor] : "white"};
      transition: all ease-in-out 0.2s;

      &:hover, &:focus, &:active {
        border-color: ${props.backgroundColor ? props.theme.colors[props.backgroundColor] : props.theme.colors.Primary500};
        box-shadow: 0px 1px 6px -2px ${props.theme.colors.Neutral900};
      }

      &.negative-action {
        background: ${props.theme.colors.AccentRed500};
        border-color: ${props.theme.colors.AccentRed500};
        color: white;

        &:hover {
          box-shadow: 0px 0px 15px ${props.theme.colors.AccentRed500};
        }
      }
    `};
  ${props =>
    props.small &&
    css`
      height: auto;
      padding: 0.3rem 1.2rem;
      border-radius: ${props.theme.borderRadius.small};
      font-size: ${props.theme.font.sizes.small}
    `};
`;

export const Button: React.FC<ButtonProps> = props => {
  const { iconDirection, display } = props;
  const iconDir: boolean = iconDirection === "right" || false;

  return (
    <Wrapper display={display}>
      <StyledButton disabled={props.loading || props.disabled} reverse={iconDir} {...props} />
    </Wrapper>
  );
};
